// src/shared/services/apiConfig.ts

/**
 * Configuración base de la API
 * Backend ubicado en: https://www.ibloom.cl/api
 * NOTA: La estructura real del servidor es /api/api/v1/ pero por compatibilidad
 * con el .htaccess existente en /auth/, usamos /api como base
 */
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://www.ibloom.cl/api/api';


export const getFullImageUrl = (relativePath: string | null | undefined): string | null => {
  if (!relativePath) return null;
  
  if (relativePath.startsWith('http://') || relativePath.startsWith('https://')) {
    return relativePath;
  }
  
  return `${API_BASE_URL}${relativePath}`;
};

/**
 * Endpoints organizados según la estructura real del backend
 * Todos los endpoints incluyen .php al final
 */
export const API_ENDPOINTS = {
  // Autenticación - /api/api/v1/auth/
  AUTH: {
    GOOGLE_LOGIN: '/v1/auth/google.php',
  },

  // Usuarios - /api/api/v1/users/
  USERS: {
    PROFILE: '/v1/users/profile.php',      // GET: obtener perfil, PUT: actualizar perfil
    DASHBOARD: '/v1/users/dashboard.php',  // GET: obtener dashboard del usuario
  },

  // Competencias - /api/api/v1/competitions/
  // IMPORTANTE: competitions necesita /api adicional + .php
  COMPETITIONS: {

    GET_EVENT_INFO: '/v1/competitions/info/get.php', 
    GET_EVENT_LIST: '/v1/competitions/info/get-list-all.php', 
    LIST: '/v1/competitions/list.php',
    DETAILS: '/v1/competitions/details.php',
    REGISTER: '/v1/competitions/register.php',
    REGISTRATION_STATUS: '/v1/competitions/registration-status.php',
    REGISTER_CATEGORY: '/v1/competitions/register-category.php',
    MY_REGISTRATIONS: '/v1/competitions/my-registrations.php',
    STATUS: '/v1/competitions/status.php',
    SUBMIT_IMAGE: '/v1/competitions/submit-image.php',
    GET_IMAGE: '/v1/competitions/get-image.php',
    TERMS: '/v1/competitions/terms.php',
    GET_IMAGE_TYPES: '/v1/competitions/get-image-types.php',
    GET_CRITERIA: '/v1/competitions/get-criteria.php',
    GET_EXAMPLE_IMAGES: '/v1/competitions/get-example-images.php',
    GET_EXAMPLE_IMAGE: '/v1/competitions/get-example-image.php',
    DELETE_SUBMISSION: '/v1/competitions/delete-submission.php',
    CHECK_PARTICIPANT: '/v1/competitions/judge/check-participant.php',


    // ✅ NUEVOS: Endpoints de videos
    GET_VIDEO_TYPES: '/v1/competitions/players/video/get-video-types.php',
    SUBMIT_VIDEO: '/v1/competitions/players/video/submit-video.php',
    DELETE_VIDEO: '/v1/competitions/players/video/delete-video.php',
    GET_PARTICIPANT_VIDEO: '/v1/competitions/players/video/get-participant-video.php',
    GET_VIDEO_CRITERIA: '/v1/competitions/players/video/get-video-criteria.php',
    GET_EXAMPLE_VIDEOS: '/v1/competitions/players/video/get-example-videos.php',
    GET_EXAMPLE_VIDEO: '/v1/competitions/players/video/get-example-video.php',
    GENERATE_VIDEO_TOKEN: '/v1/competitions/players/video/generate-video-token.php',

  },

  JUDGE: {
    APPLY: '/v1/competitions/judge/apply.php',
    STATUS: '/v1/competitions/judge/status.php',
    STATUS_BY_EVENT: '/v1/competitions/judge/status-by-event.php',
    APPLY_LEVEL: '/v1/competitions/judge/apply-level.php',
    MY_LEVELS: '/v1/competitions/judge/my-levels.php',
    EVALUATIONS: '/v1/competitions/judge/evaluations.php',
    EVALUATE: '/v1/competitions/judge/evaluate.php',
    MY_EVALUATIONS: '/v1/competitions/judge/my-evaluations.php',
    TERMS: '/v1/competitions/judge/terms.php',
    ACCEPT_TERMS: '/v1/competitions/judge/accept-terms.php',
    CHECK_REGISTRATION: '/v1/competitions/judge/check-registration.php',
    
    // ✅ NUEVOS ENDPOINTS PARA COLLAGE DE PARTICIPANTES
    PARTICIPANTS_WITH_MEDIA: '/v1/competitions/judge/info/get-list-participant.php',
    PARTICIPANTS_LIST: '/v1/competitions/judge/participants-list.php',
    PARTICIPANT_DETAILS: '/v1/competitions/judge/participant-details.php',
    VIDEO_EVALUATE: '/v1/competitions/judge/video/evaluate.php',
    VIDEO_EVALUATIONS: '/v1/competitions/judge/video/evaluations.php',
  },
} as const;

/**
 * Configuración de timeouts y reintentos
 */
export const API_CONFIG = {
  TIMEOUT: 30000, // 30 segundos para imágenes
  MAX_RETRIES: 3,
  RATE_LIMIT: {
    REQUESTS_PER_MINUTE: 60,
  },
} as const;

/**
 * Headers por defecto
 */
export const DEFAULT_HEADERS = {
  'Accept': 'application/json',
} as const;

/**
 * Configuración de autenticación
 */
export const AUTH_CONFIG = {
  TOKEN_KEY: 'ibloom_auth_token',
  REFRESH_TOKEN_KEY: 'ibloom_refresh_token',
  USER_KEY: 'ibloom_user_data',
  TOKEN_EXPIRY_BUFFER: 5 * 60 * 1000, // 5 minutos
} as const;

/**
 * Configuración de Google OAuth
 */
export const GOOGLE_CONFIG = {
  CLIENT_ID: '378111053-lddpk9oots3hor6ffmjebsh4e7jlch0p.apps.googleusercontent.com',
  SCOPES: 'email profile',
} as const;